<!-- Start: Numeric -->
<app-element-container
  [element]="element"
  [hasEntries]="hasEntries"
  [allElements]="allElements"
  [showCompletionWarning]="showCompletionWarning"
  (remove)="elementRemove.emit(element)"
  (manage)="elementManage.emit(element)"
  (moveUp)="elementMoveUp.emit(element)"
  (moveDown)="elementMoveDown.emit(element)"
  (addMessage)="messageAdd.emit(element)"
  (editMessage)="messageEdit.emit($event)"
  (removeMessage)="messageRemove.emit($event)"
  (visibilityEdit)="visibilityEdit.emit(element)">
  <div class="form-element-answer single-line-text">
    <input type="number" [placeholder]="element.placeholder" />
  </div>
</app-element-container>
<!-- End: Numeric -->
